import React from "react";
import "./Spinner.scss";

const Spinner = () => {
  return (
    <div className="Spinner">
      <div className="whirly-loader"></div>
    </div>
  );
};

export default Spinner;
